import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-agb-page",
  templateUrl: "./AgbPage.html",
})
export class AgbPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

  public get organization() {
    return this.appController.organization;
  }

  public get agbText() {
    return this.appController.agbText;
  }

}
